import { IQueueActions } from "../../action-types/queue/IQueueActions";
import { IQueueReducer } from "../../reducer-model/queue/IQueueReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IQueueReducer = {
    status: eReducerStatusBase.is_not_initialization,
    inQueue: false,
    hasAccess: false,
    position: null,
    estimatedSeconds: null,
    queueSize: null,
    token: null,
    periodClosed: false,
    error_message: "",
    openAt: null,
    closeAt: null,
    enforceTimeWindow: true,
    allowPreviewBeforeOpen: false,
    allowEarlyRegistration: false,
};

export const queueReducer = (state: IQueueReducer = initialState, action: IQueueActions): IQueueReducer => {
    switch (action.type) {
        case "QUEUE_LOAD_STATUS_START":
            return { ...state, status: eReducerStatusBase.is_loading, error_message: "" };
        case "QUEUE_LOAD_STATUS_SUCCESS": {
            const p = action.payload;
            // hasAccess KHÔNG hạ true→false từ snapshot HTTP: /queue/status là ảnh chụp tại 1 thời điểm,
            // có thể về SAU event SignalR ACCESS_GRANTED (đã cấp access) → nếu ghi đè sẽ kẹt lại
            // QueueWaitingPage, phải F5 mới vào /classes. Access chỉ thu hồi qua PERIOD_CLOSED / RESET.
            const grantedAccess = state.hasAccess || !!p.hasAccess;
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                inQueue: grantedAccess ? false : !!p.inQueue,
                hasAccess: grantedAccess,
                position: grantedAccess ? null : (p.position ?? null),
                estimatedSeconds: grantedAccess ? null : (p.estimatedSeconds ?? null),
                token: p.token ?? state.token,
                openAt: p.openAt ?? state.openAt,
                closeAt: p.closeAt ?? state.closeAt,
                enforceTimeWindow: p.enforceTimeWindow ?? state.enforceTimeWindow,
                allowPreviewBeforeOpen: p.allowPreviewBeforeOpen ?? state.allowPreviewBeforeOpen,
                allowEarlyRegistration: p.allowEarlyRegistration ?? state.allowEarlyRegistration,
            };
        }
        case "QUEUE_LOAD_STATUS_ERROR":
            return { ...state, status: eReducerStatusBase.is_error, error_message: action.payload };
        case "QUEUE_SET_POSITION": {
            const p = action.payload;
            // SET_POSITION = push SignalR real-time (ordered per-connection: QueuePosition luôn tới TRƯỚC
            // AccessGranted) HOẶC lệnh re-queue chủ động khi mất access (handleQueueRejection 403). Cả 2
            // đều authoritative → áp thẳng, KỂ CẢ hạ hasAccess=false. (Race login đã chặn ở LOAD_STATUS_SUCCESS
            // — đó là snapshot HTTP mới có thể đến trễ & clobber; SET_POSITION thì không.)
            return {
                ...state,
                inQueue: !!p.inQueue,
                hasAccess: !!p.hasAccess,
                position: p.position ?? null,
                estimatedSeconds: p.estimatedSeconds ?? null,
                token: p.token ?? state.token,
            };
        }
        case "QUEUE_TICK": {
            const p = action.payload;
            return {
                ...state,
                queueSize: p.queueSize,
                position: state.position != null ? Math.max(0, state.position - p.cleared) : state.position,
                estimatedSeconds:
                    state.position != null
                        ? Math.max(0, Math.ceil((state.position - p.cleared) / 800))
                        : state.estimatedSeconds,
            };
        }
        case "QUEUE_ACCESS_GRANTED":
            return {
                ...state,
                inQueue: false,
                hasAccess: true,
                token: action.payload.token,
                position: null,
                estimatedSeconds: null,
            };
        case "QUEUE_PERIOD_CLOSED":
            return { ...state, periodClosed: true, hasAccess: false, inQueue: false };
        case "QUEUE_PERIOD_OPENED":
            // Reset cờ closed (trường hợp SV vừa rời /closed) + ép status về not_initialization
            // để LandingPage trigger LOAD_STATUS_START lần nữa qua effect, đồng thời saga
            // gọi /queue/status để server cấp QueuePosition mới (ZADD + token).
            return {
                ...state,
                status: eReducerStatusBase.is_not_initialization,
                periodClosed: false,
                error_message: "",
            };
        case "QUEUE_RESET":
            return { ...initialState };
        default:
            return state;
    }
};
